<template>
  <div>
      <a
          href="javascript:;"
          data-toggle="modal"
          id="modal-success"
          style="display: none"
          data-target="#success-modal-preview"
          class="button inline-block bg-theme-1 text-white"
      ></a>
    <div id="success-modal-preview" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <CheckCircleIcon
              class="w-16 h-16 text-theme-9 mx-auto mt-3"
          />
          <div class="text-gray-600 mt-2">
            {{modalText}}
          </div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
              type="button"
              data-dismiss="modal"
              class="button w-24 bg-theme-1 text-white"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
    <a
        href="javascript:;"
        data-toggle="modal"
        data-target="#warning-modal-preview"
        style="display: none"
        id="show-modal"
        class="button inline-block bg-theme-1 text-white"
    >Show Modal</a
    >
    <div id="warning-modal-preview" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <xCircleIcon class="w-16 h-16 text-theme-12 mx-auto mt-3" />
          <div class="text-3xl mt-5">Oops...</div>
          <div class="text-gray-600 mt-2">{{modalText}}</div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
              type="button"
              data-dismiss="modal"
              class="button w-24 bg-theme-1 text-white"
          >
            Ok
          </button>
        </div>
        <div
            class="p-5 text-center border-t border-gray-200 dark:border-dark-5"
        >
        </div>
      </div>
    </div>
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">
        Choose xlsx file for upload
      </h2>
    </div>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-6">
        <!-- BEGIN: File Type Validation -->
        <div class="intro-y box">
          <div
            class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200 dark:border-dark-5"
          >
            <h2 class="font-medium text-base mr-auto">Upload bionet additional data</h2>
          </div>

          <div id="file-type-validation" class="p-5">
            <div class="preview">
              <VueDropzone
                id="dropzone-validation"
                ref="MyDropzone"
                :use-custom-slot="true"
                :options="{
                  url: 'https://httpbin.org/post',
                  maxFiles: 1,
                  addRemoveLinks: true
                }"
                class="dropzone font-roboto border-gray-200 border-dashed text-gray-800 hover:bg-transparent"
                @vdropzone-file-added="validateFileEvent"
                @vdropzone-error="dropzoneError"
                @vdropzone-removed-file="removeEvent"
              >
                <div class="text-lg font-medium">
                  Drop files here or click to upload.
                </div>
                <div class="text-gray-600"></div>
              </VueDropzone>
            </div>
          </div>
          <div class="text-center">
            <button
                type="button"
                class="button inline-block bg-theme-1 text-white"
                :disabled="file === null"
                @click="createFile"
            >
              Upload
            </button>
          </div>
        </div>
        <!-- END: File Type Validation -->
      </div>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import axios from "axios";

export default {
  components: {
    VueDropzone: vue2Dropzone
  },
  data: function() {
    return {
      file: null,
      modalText: "",
    };
  },
  mounted() {
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    validateFileEvent(file) {
      this.file = file;
    },
    createFile() {

      axios
        .put("bionet/upload/additional/", this.file, {
          headers: {
            "Content-Disposition":
              "attachment; filename=" + this.file.upload.filename,
          }
        })
        .then(response => {
          if (response.data.status && response.data.status === "success") {
            // console.log(response.data);
            this.modalText = "File success uploaded"
            document.getElementById("modal-success").click()

          } else {
            this.modalText = "Err. File not uploaded"
            document.getElementById("show-modal").click()
          }
          this.$refs.MyDropzone.removeFile(this.file);
        })
        .catch(err => {
          // console.log(err);
          this.error = err;
        });
    },
    dropzoneError(err) {
      console.log(err);
      // if (!err.type.includes("ms-excel")) {
      //   alert("Error! Files of this type are not accepted");
      // }
    },
    // eslint-disable-next-line no-unused-vars
    removeEvent(file) {
      // console.log(file);
      this.file = null;
    }
  }
};
</script>
<style>
.button.inline-block.bg-theme-1.text-white{
  margin-bottom: 20px;
}
</style>
